"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_merge_refs_1 = __importDefault(require("react-merge-refs"));
var ThemeProvider_1 = require("../ThemeProvider");
var Handle_1 = __importStar(require("./Handle"));
var cropFallback = {
    top: 0,
    left: 0,
    width: 1,
    height: 1,
};
var Crop = react_1.forwardRef(function Crop(_a, ref) {
    var className = _a.className, controlledCrop = _a.crop, defaultCrop = _a.defaultCrop, onChange = _a.onChange, _b = _a.onCropEnd, onCropEnd = _b === void 0 ? function (changed) { return changed; } : _b, _c = _a.onCropStart, onCropStart = _c === void 0 ? function (changed) { return changed; } : _c, _d = _a.square, square = _d === void 0 ? false : _d, src = _a.src;
    var theme = (react_1.useContext(ThemeProvider_1.ThemeContext) || {}).theme;
    var previewRef = react_1.useRef(null);
    var wrapperRef = react_1.useRef(null);
    var _e = react_1.useState(null), mouseDownData = _e[0], setMouseDownData = _e[1];
    var _f = react_1.useState(false), previewVisible = _f[0], setPreviewVisible = _f[1];
    var _g = react_1.useState(false), wrapperClicked = _g[0], setWrapperClicked = _g[1];
    var _h = react_1.useState(controlledCrop || defaultCrop || cropFallback), crop = _h[0], setCrop = _h[1];
    if (controlledCrop && onChange === Function.prototype) {
        throw new Error('please add onChange if you choose to controll this component yourself');
    }
    react_1.useEffect(function () {
        // SETTING THE STATE FOR CONTROLLED COMPONENT or if image path is changing
        setCrop(controlledCrop || defaultCrop || cropFallback);
    }, [controlledCrop, src]);
    react_1.useEffect(function () {
        setPreviewVisible(false);
        if (previewVisible === false) {
            var img = new Image();
            img.onload = function () {
                setPreviewVisible(true);
            };
            img.src = src;
            if (img.complete) {
                setPreviewVisible(true);
            }
        }
    }, [src]);
    var handleWrapperClick = function () {
        if (wrapperClicked) {
            if (onChange) {
                onChange(cropFallback);
            }
            else
                setCrop(cropFallback);
            if (controlledCrop === undefined) {
                setCrop(cropFallback);
            }
        }
        setWrapperClicked(true);
        setTimeout(function () {
            setWrapperClicked(false);
        }, 400);
    };
    var mouseMove = function (position) { return function (mouseData) { return function (e) {
        var clientX = e.clientX, clientY = e.clientY, altKey = e.altKey;
        var x = mouseData.x, y = mouseData.y;
        var xDelta = clientX - x;
        var yDelta = clientY - y;
        var wrapper = wrapperRef.current;
        e.preventDefault();
        var bounds;
        if (wrapper) {
            bounds = {
                x: wrapper.offsetTop,
                y: wrapper.offsetLeft,
                width: wrapper.offsetWidth,
                height: wrapper.offsetHeight,
            };
        }
        else {
            bounds = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            };
        }
        /**
         * Drag
         */
        if (position === undefined) {
            var dragLeft = (crop.left * bounds.width + xDelta) / bounds.width;
            var dragTop = (crop.top * bounds.height + yDelta) / bounds.height;
            if (dragLeft < 0) {
                dragLeft = 0;
            }
            if (dragLeft + crop.width > 1) {
                dragLeft = 1 - crop.width;
            }
            if (dragTop < 0) {
                dragTop = 0;
            }
            if (dragTop + crop.height > 1) {
                dragTop = 1 - crop.height;
            }
            var newDragCrop = __assign(__assign({}, crop), { top: dragTop, left: dragLeft, delta: { x: xDelta, y: yDelta } });
            if (onChange === undefined) {
                onChange = setCrop;
            }
            onChange(newDragCrop);
            if (controlledCrop === undefined) {
                setCrop(newDragCrop);
            }
            return;
        }
        /**
         * Handle implementation
         */
        var changeTop = position.includes('Top');
        var changeLeft = position.includes('Left');
        /**
         *
         * TOP
         *
         */
        var newTop = (crop.top * bounds.height + yDelta) / bounds.height;
        var addToHeight = yDelta * (changeTop ? -1 : 1);
        if (newTop < 0) {
            newTop = 0;
            if (changeTop) {
                addToHeight = 0;
            }
        }
        if (newTop > 1) {
            newTop = 1;
        }
        /**
         *
         * LEFT
         *
         */
        var newLeft = (crop.left * bounds.width + xDelta) / bounds.width;
        var addToWidth = xDelta * (changeLeft ? -1 : 1);
        if (newLeft < 0) {
            newLeft = 0;
            if (changeLeft) {
                addToWidth = 0;
            }
        }
        if (newLeft > 1) {
            newLeft = 1;
        }
        /**
         *
         * width and height
         *
         */
        var newHeight = (crop.height * bounds.height + addToHeight) / bounds.height;
        var newWidth = (crop.width * bounds.width + addToWidth) / bounds.width;
        newTop = changeTop ? newTop : crop.top;
        newLeft = changeLeft ? newLeft : crop.left;
        /**
         * SQUARE MODE
         */
        // eslint-disable-next-line no-confusing-arrow
        var relativeProcent = function (value, horizontal) {
            return horizontal ? (value * bounds.width) / bounds.height : (value * bounds.height) / bounds.width;
        };
        if (square || altKey) {
            var pixelHeight = newHeight * bounds.height;
            var pixelWidth = newWidth * bounds.width;
            var squareWidth = pixelWidth > pixelHeight ? relativeProcent(newHeight, false) : newWidth;
            var squareHeight = pixelHeight > pixelWidth ? relativeProcent(newWidth, true) : newHeight;
            if (changeTop === false && changeLeft === false) {
                newLeft = crop.left;
                newTop = crop.top;
            }
            newWidth = squareWidth;
            newHeight = squareHeight;
        }
        /**
         * END SQUARE MODE
         */
        if (newHeight + newTop > 1) {
            newHeight = 1 - newTop;
        }
        if (newWidth + newLeft > 1) {
            newWidth = 1 - newLeft;
        }
        var newCrop = __assign(__assign({}, crop), { top: newTop, left: newLeft, height: newHeight, width: newWidth, delta: { x: xDelta, y: yDelta } });
        if (onChange === undefined) {
            onChange = setCrop;
        }
        onChange(newCrop);
        if (controlledCrop === undefined) {
            setCrop(newCrop);
        }
    }; }; };
    var mouseDownOnHandle = function (position) { return function (_a) {
        var x = _a.clientX, y = _a.clientY;
        var eventListener = mouseMove(position);
        setMouseDownData({ x: x, y: y, eventListener: eventListener });
    }; };
    var mouseDownOnPreview = function (_a) {
        var target = _a.target, x = _a.clientX, y = _a.clientY;
        if (target === previewRef.current) {
            var eventListener = mouseMove();
            setMouseDownData({ x: x, y: y, eventListener: eventListener });
        }
    };
    react_1.useEffect(function () {
        if (mouseDownData) {
            var reset_1 = function () {
                onCropEnd(crop);
                setMouseDownData(null);
            };
            onCropStart(crop);
            var eventListener = mouseDownData.eventListener;
            var move_1 = eventListener(mouseDownData);
            window.addEventListener('mousemove', move_1);
            window.addEventListener('mouseup', reset_1);
            window.addEventListener('mouseleave', reset_1);
            return function () {
                window.removeEventListener('mousemove', move_1);
                window.removeEventListener('mouseup', reset_1);
            };
        }
        return undefined;
    }, [mouseDownData, crop]);
    var _j = react_1.useState(null), setDimensions = _j[1];
    var cropToCSS = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var top = _a.top, left = _a.left, width = _a.width, height = _a.height;
        if (!wrapperRef.current || !previewVisible)
            return {};
        return {
            top: top * ((_c = (_b = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) !== null && _c !== void 0 ? _c : 0),
            left: left * ((_d = wrapperRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth),
            width: width * ((_e = wrapperRef.current) === null || _e === void 0 ? void 0 : _e.offsetWidth),
            height: height * ((_f = wrapperRef.current) === null || _f === void 0 ? void 0 : _f.offsetHeight),
            backgroundPositionY: top * ((_g = wrapperRef.current) === null || _g === void 0 ? void 0 : _g.offsetHeight) * -1,
            backgroundPositionX: left * ((_h = wrapperRef.current) === null || _h === void 0 ? void 0 : _h.offsetWidth) * -1,
            backgroundSize: ((_j = wrapperRef.current) === null || _j === void 0 ? void 0 : _j.offsetWidth) + "px auto",
        };
    };
    react_1.useEffect(function () {
        var handleResize = function () {
            setDimensions({ height: window.innerHeight, width: window.innerWidth });
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [cropToCSS]);
    var classes = useStyles({ src: src });
    return (jsx_runtime_1.jsxs("div", __assign({ className: classnames_1.default(classes.wrapper, className), ref: react_merge_refs_1.default([wrapperRef, ref]), onClick: handleWrapperClick }, { children: [jsx_runtime_1.jsx("img", { onLoad: function () { return setPreviewVisible(true); }, src: src, alt: "the cropped preview" }, void 0),
            jsx_runtime_1.jsx("div", { className: classes.background }, void 0),
            jsx_runtime_1.jsx("div", __assign({ onMouseDown: mouseDownOnPreview, className: classes.preview, style: __assign(__assign({}, cropToCSS(crop)), { display: previewVisible ? 'block' : 'none' }), ref: previewRef }, { children: Object.values(Handle_1.HANDLE_POSITIONS).map(function (position) { return (jsx_runtime_1.jsx(Handle_1.default, { onDragStart: function (e) { return e.preventDefault(); }, onMouseDown: mouseDownOnHandle(position), position: position, handleColor: theme && theme.palette.primary.main }, position)); }) }), void 0)] }), void 0));
});
exports.default = Crop;
var useStyles = core_1.makeStyles({
    preview: {
        background: function (_a) {
            var src = _a.src;
            return "url(" + src + ")";
        },
        backgroundRepeat: 'no-repeat',
        border: '2px dashed rgba(0, 0, 0, 0.8)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    wrapper: {
        position: 'relative',
        display: 'table',
        '& > img': {
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
    background: {
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(5px)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
});
//# sourceMappingURL=Crop.js.map